module.exports = __webpack_public_path__ + "img/stretching_guide.c8b987a4.png";